import { render, staticRenderFns } from "./gxcj.vue?vue&type=template&id=ed5efce0&scoped=true&"
import script from "./gxcj.vue?vue&type=script&lang=js&"
export * from "./gxcj.vue?vue&type=script&lang=js&"
import style0 from "./gxcj.vue?vue&type=style&index=0&id=ed5efce0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5efce0",
  null
  
)

export default component.exports